import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RotinaProgramadaModel} from '../model/rotina-programada/rotina-programada-model';

@Injectable({
  providedIn: 'root'
})
export class RotinaProgramadasService {

  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}`;

  buscarTodos(noLoading: boolean): Observable<RotinaProgramadaModel[]>{
    return this.http.get<RotinaProgramadaModel[]>(`${this.urlBase}/rotina-programada`,
      { headers: { 'no-loading': noLoading ? 'true' : 'false' } });
  }

}
